// Web polyfill for react-native-screens/native-stack
// Provides a safe fallback on web by delegating to @react-navigation/stack

import { createStackNavigator } from '@react-navigation/stack';

export const createNativeStackNavigator = () => {
  console.warn('[react-native-screens/native-stack] Using createStackNavigator fallback on web');
  return createStackNavigator();
};

const nativeStackPolyfill = {
  createNativeStackNavigator,
};

export default nativeStackPolyfill;

if (typeof globalThis !== 'undefined' && !globalThis.__RN_SCREENS_NATIVE_STACK_POLYFILL__) {
  globalThis.__RN_SCREENS_NATIVE_STACK_POLYFILL__ = nativeStackPolyfill;
}
